import PodcastContentTable from 'components/PodcastContentTable';
import useMobileBreakpoint from 'hooks/useMobileBreakpoint';
import { useGetPodcastSocialShareStatsDetails } from 'pages/headliner/state';
import EpisodesMobileList from './EpisodesMobileList';
import { SocialSharePodcastEpisode } from './types';
import columns from './utils';

type VideosByEpisodeTableProps = {
  podcastId: string;
  onRowClick?: (val: SocialSharePodcastEpisode) => void;
};

const VideosByEpisodeTable: React.FC<VideosByEpisodeTableProps> = ({
  podcastId,
  onRowClick,
}) => {
  const { data: details, isLoading } =
    useGetPodcastSocialShareStatsDetails(podcastId);
  const isMobile = useMobileBreakpoint('md');

  return isMobile ? (
    <EpisodesMobileList podcastId={podcastId} onClick={onRowClick} />
  ) : (
    <PodcastContentTable<SocialSharePodcastEpisode>
      columns={columns}
      podcastData={details ?? []}
      isLoading={isLoading}
      tableLayout="fixed"
      onRowClick={onRowClick}
    />
  );
};
export default VideosByEpisodeTable;
